/**
 * Filters AI SDK / fetch stream errors so benign client-side failures are not sent to Sentry.
 * Used by org Kin and partner advisor chat hooks.
 */
const AGENT_CHAT_STREAM_IGNORED_ERROR_PATTERNS = [
  /^(typeerror:\s*)?network error$/i,
  /^(typeerror:\s*)?failed to fetch$/i,
  /^load failed$/i,
  /^aborterror\b/i,
  /^request aborted\b/i,
  /^request cancelled\b/i,
];

export function shouldCaptureAgentChatStreamError(error: Error): boolean {
  const message = error.message?.trim() ?? '';
  const fullMessage = `${error.name ? `${error.name}: ` : ''}${message}`.trim();
  return !AGENT_CHAT_STREAM_IGNORED_ERROR_PATTERNS.some(
    pattern => pattern.test(message) || pattern.test(fullMessage)
  );
}
